import React, { useEffect, useRef, useState } from 'react'
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import '../../../common/rsuite-datepicker.css';
import fetchAPI from '../../../common/fetchAPI';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
// import Loader from '../../../common/Loader';
import { normalizeDateFormat, getValueFromResource, dateFormatByAccountCultureForFilters } from '../../../common/timeLiveFunction';
import { resetSelectedRecordObjectInState } from "./CustomReportViewSlice";
import { useTranslation } from 'react-i18next';
import { format, parseISO } from 'date-fns';
import DatePickerRanges from '../../../common/DatePickerRanges';
import { CSVLink } from 'react-csv';
import Papa from "papaparse";

const MonthlyReportFilter = (props: any) => {
    const { AccountReportId, onDateChange, onHandleOnClickEvent } = props;
    const { filterDropDownList } = useAppSelector((state) => state.customReportView);
    const properties = Object.keys(filterDropDownList);
    // const [numberOfFilters, setNumberOfFilters] = useState<number>(20);
    const dispatch = useAppDispatch();
    const { CurrentCultureDateFormat, cultureInfoName } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const [displayedRange, setDisplayedRange] = useState(t('Please Select Date Range'));
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [SelectedExportData, setSelectedExportData] = useState('');
    const [SelectedFileName, setSelectedFileName] = useState('');
    const [SelectedColumnHeaders, setSelectedColumnHeaders] = useState<any | ''>([]);
    const csvLinkRef = useRef<any>();
    const accountId = localStorage.getItem('accountId');

    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
    };

    useEffect(() => {
        if (SelectedFileName) {
            if (csvLinkRef.current) {
                csvLinkRef.current.link.click();
            }
        }

    }, [SelectedFileName])

    useEffect(() => {
        const formattedStartDate = format(startDate, 'MM-dd-yyyy');
        const formattedEndDate = format(endDate, 'MM-dd-yyyy');
        onDateChange(formattedStartDate, formattedEndDate);
    }, [startDate, endDate]);

    const handleDateRangeChange = (value: any) => {
        if (value && value[0] && value[1]) {
            const formattedStartDate = format(value[0], CurrentCultureDateFormat.toString());
            const formattedEndDate = format(value[1], CurrentCultureDateFormat.toString());
            const apiStartDate = format(value[0], 'MM-dd-yyyy');
            const apiEndDate = format(value[1], 'MM-dd-yyyy');
            onDateChange(apiStartDate, apiEndDate);
            setDisplayedRange(`${formattedStartDate} - ${formattedEndDate}`);
        } else {
            setDisplayedRange('Please Select Date Range');
        }
        setStartDate(dateFormatByAccountCultureForFilters(format(value[0], "yyyy-MM-dd"), cultureInfoName.toString()));
        setEndDate(dateFormatByAccountCultureForFilters(format(value[1], "yyyy-MM-dd"), cultureInfoName.toString()));
    };

    const handleMonthlyReport = async () => {
        if (!startDate || !endDate) return;

        const formattedStartDate = format(startDate, 'MM-dd-yyyy');
        const formattedEndDate = format(endDate, 'MM-dd-yyyy');

        const response: any = await fetchAPI(
            `api/V2/Reports/GenerateMonthlyJournalReportCSV/${accountId}/${formattedStartDate}/${formattedEndDate}`,
            "POST",
            "",
            true
        );

        const json = await response.json();
        const { data, FileName } = json;
        if (data !== undefined && data !== "") {
            setSelectedColumnHeaders(data.length > 0 ? Object.keys(data[0]) : []);

            const csv = Papa.unparse(data, {
                quotes: false,
                delimiter: ',',
                header: false 

            });
            setSelectedExportData(csv);
            setSelectedFileName(FileName);
        }
    }

    return (
        <>
            {/* {isLoading && <Loader />} */}
            <div className='card-body'>
                <div className='row' >
                    <div className='col-md-6'>
                        <label className="fs-7 fw-normal mb-2">
                            {/* {t('Date Range')} */}
                            {getValueFromResource('Date Range', dispatch, t)}
                        </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges()}
                                value={[startDate, endDate]}
                                // placeholder={t('Please Select Date Range')}
                                placeholder={displayedRange}
                                character={' - '}
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                </div>

            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            //ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                            {/* {t('Apply Filter')} */}
                            {getValueFromResource('Apply Filter', dispatch, t)}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            data-kt-element='send'
                            id='kt_OffCanvas_close'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters', dispatch, t)}
                        </button>
                        <button
                            id="kt_OffCanvas"
                            type="button"
                            //data-kt-element='send'
                            className="btn btn-primary btn-sm fs-7 "
                            onClick={handleMonthlyReport}
                        >
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters', dispatch, t)}
                        </button>
                    </div>
                </div>
            </div>
            <CSVLink data={SelectedExportData} headers={SelectedColumnHeaders} filename={SelectedFileName} ref={csvLinkRef}  >
            </CSVLink>
        </>
    )
}

export default MonthlyReportFilter